export default __webpack_public_path__ + "static/media/malware_infected_computers.b6c4027e.svg";